import React from 'react';


export const BookComponent = ({ book, checkboxChange, selectedBooks, check = true }) => {
    return (
        <div className="book col-sm-6 col-md-4 col-lg-3 d-flex flex-column align-items-center mb-4">
            <img className="mb-2" src={book.image} alt={book.title} width="186" height="290" />
            {check && <>
                <h2 className="book-title text-center fw-bold ps-2">{book.title}</h2>
                <h3 className="book-price text-center">Verð: {book.price} kr.</h3>
                <label className="book-price"><input type="checkbox" id={book.id} onChange={() => checkboxChange(book)} checked={selectedBooks.includes(book)}></input> Bæta í körfu</label>
            </>}
        </div>
    )
}